"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BASE_STANDARD_USER_FACING_DATABASE_ROLES = exports.VIEW_CONFIG_MANAGED_BY = exports.APP_BASE_STANDARD_DATABASE_MANAGED_BY_PREFIX = void 0;
exports.resolveAppBaseStandardDatabaseRole = resolveAppBaseStandardDatabaseRole;
exports.isUserFacingAppBaseStandardDatabaseRole = isUserFacingAppBaseStandardDatabaseRole;
exports.isHiddenSystemManagedDatabase = isHiddenSystemManagedDatabase;
const file_index_1 = require("./file-index");
exports.APP_BASE_STANDARD_DATABASE_MANAGED_BY_PREFIX = 'app-base-standard:';
exports.VIEW_CONFIG_MANAGED_BY = 'view-config';
exports.APP_BASE_STANDARD_USER_FACING_DATABASE_ROLES = [
    'clusters',
    'topics',
    'users',
    'content',
    'forms',
    'submissions',
];
const APP_BASE_STANDARD_USER_FACING_DATABASE_ROLE_SET = new Set(exports.APP_BASE_STANDARD_USER_FACING_DATABASE_ROLES);
function resolveAppBaseStandardDatabaseRole(managedBy) {
    if (typeof managedBy !== 'string')
        return null;
    if (!managedBy.startsWith(exports.APP_BASE_STANDARD_DATABASE_MANAGED_BY_PREFIX)) {
        return null;
    }
    const role = managedBy.slice(exports.APP_BASE_STANDARD_DATABASE_MANAGED_BY_PREFIX.length);
    return role.length > 0 ? role : null;
}
function isUserFacingAppBaseStandardDatabaseRole(role) {
    return APP_BASE_STANDARD_USER_FACING_DATABASE_ROLE_SET.has(role);
}
function isHiddenSystemManagedDatabase(input) {
    const isFileIndex = input.managedBy === file_index_1.FILE_INDEX_MANAGED_BY ||
        (0, file_index_1.isFileIndexDatabaseId)(input.id);
    if (isFileIndex)
        return input.visible !== true;
    if (input.managedBy === exports.VIEW_CONFIG_MANAGED_BY)
        return true;
    const appBaseStandardRole = resolveAppBaseStandardDatabaseRole(input.managedBy);
    if (!appBaseStandardRole)
        return false;
    return !isUserFacingAppBaseStandardDatabaseRole(appBaseStandardRole);
}
